export const Post=(link:string,id:string)=>
{
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "nombreComuna": "Santiago",
                "Cantidad": 1
              });

            var requestOptions:any = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body:raw,
            
            };
            const datos= fetch(link, requestOptions)
            const prueba=datos.then(resultado=>resultado.json())
            const dato=prueba.then(resultado=>
                {
                    const contenido=resultado;
                    return contenido
                })
            return dato            
}

export const Get=(link:string)=>
{
            var requestOptions:any = {
            method: 'GET',
            redirect: 'follow'
            };
            const datos= fetch(link, requestOptions)
            const prueba=datos.then(resultado=>resultado.json())
            const dato=prueba.then(resultado=>
                {
                    const contenido=resultado;
                    return contenido
                })
            return dato            
}